<template>
  <div class="pillars row">
    <div class="grid-2-g grid-1-m hide-s"></div>
    <div class="column grid-8-g grid-10-m grid-12-s">
      <div class="head column">
        <div class="title">
          <strong>Nossos Pilares</strong>
        </div>
        <span></span>
      </div>
      <div class="content grid-12 grid-10-g">
        <div class="product row column-s align-center">
          <!--  <div class="avatar grid-3">
            <img src="../assets/img/ico_ns_community.svg" />
          </div>-->
          <div class="product-content column grid-9 grid-12-s">
            <div class="title">
              <strong></strong> Aprender e Ensinar
            </div>
            <p>
              Na NetSupport valorizamos muito o significado das palavras “Aprender e Ensinar”, pois uma caminha ao lado da outra.
              Acreditamos que o conhecimento constrói seres humanos mais dignos e profissionais mais qualificados para o mercado de trabalho, por isso investimos em tecnologias e ideias que incentivam o aprendizado e compartilhamento de experiências.
              Diariamente aprendemos coisas novas, sejam elas de cunho pessoal ou profissional, e quando já temos um determinado conhecimento, ensinar o outro torna-se algo primordial, pois assim ajudamos a construir novas gerações.
            </p>
          </div>
        </div>
        <div class="product row align-center column-s">
        <!--   <div class="avatar grid-3 hide-m hide-g">
            <img src="../assets/img/ico_ns_academy.svg" />
          </div> -->
          <div class="product-content column grid-9 grid-12-s">
            <div class="title">
              <strong></strong> Relacionar
            </div>
            <p>
              Apaixonados por tecnologia e como ela pode melhorar a vida das pessoas, sonhamos em formar a maior comunidade de TI do mundo.
              Acreditamos que com isso é possível proporcionar muitas vantagens como, compartilhamento de experiências, desenvolvimento pessoal e profissional, além de render boas amizades e conexões
              Por isso, na NetSupport, incentivamos Supporters, clientes e colaboradores a construírem relações fortes, aumentando a proximidade e a fortalecendo a relação para crescermos em conjunto.
            </p>
          </div>
          <!--          <div class="avatar grid-2 hide-s">
            <img src="../assets/img/ico_ns_academy.svg" />
          </div>-->
        </div>
        <div class="product column-s row align-center">
          <!--    <div class="avatar grid-3">
            <img src="../assets/img/ico_ns_support.svg" />
          </div>-->
          <div class="product-content column grid-9 grid-12-s">
            <div class="title">
              <strong></strong> Ganhar dinheiro
            </div>
            <p>
              Sabemos o quanto ter uma renda extra pode fazer toda diferença no final do mês. O mercado de trabalho está cada vez mais exigente, inconstante e o número de pessoas desempregadas só cresce a cada dia no Brasil.
              Por isso é fundamental encontrar oportunidades que possibilitem você fugir dessa estatística.
              A NetSupport acredita que todos merecem brilhar e ter sucesso em sua carreira, por isso, oferecemos oportunidades a todos. Aqui não importa as suas caraterísticas e sim o seu perfil profissional. Se você é fera em TI, venha mostrar as suas habilidades na nossa plataforma.
              Acreditamos no seu potencial e nos seus sonhos, por isso não colocamos obstáculos no seu caminho e deixamos você mostrar o que tem de melhor.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pillars",
  mounted() {
    this.$parent.$children[0].changeMenu("pillars");
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.pillars {
  color: $gray-1;
  padding-bottom: 100px;
  .head {
    @media (max-width: $small) {
      align-items: center;
      padding: 10px;
    }
    span {
      font-size: 19px;
      @media (max-width: $small) {
        font-size: 15px;
      }
    }
  }
  .title {
    padding-top: 90px;
    @media (max-width: $small) {
      padding-top: 45px;
      font-size: 20px;
    }
    @media (max-width: $medium) and (min-width: $small) {
      font-size: 20px;
    }
    font-size: 27px;
    color: $black;
    font-weight: 500;
  }

  .avatar {
    width: 130px;
    height: 130px;
    &:nth-of-type(2) {
      margin-left: 50px;
    }
  }
  .content {
    margin-top: 40px;
    .product {
      border-bottom: 1px solid $white-7;
      @media (max-width: $small) {
        padding: 30px;
      }
      .title {
        font-weight: bold;
        color: $green-6;
        padding-top: 12px;
        strong {
          color: $green-7;
        }
      }

      &-content {
        font-size: 13px;
        padding-bottom: 40px;
        @media (min-width: $small) {
          padding: 40px;
        }

        & p {
          margin-top: 11px;
          text-align: justify;
        }

        &:nth-of-type(1) {
          padding-left: 0px;
          padding-right: 0px;
          padding-top: 40px;
        }
        &:nth-of-type(2) {
          padding-top: 40px;
        }
      }
    }
  }
}
</style>